/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MissionNoticeAcknowledgementDto } from './missionNoticeAcknowledgementDto';
import { NoticeDto } from './noticeDto';

export interface MissionNoticeDto {
    notice: NoticeDto;
    status: MissionNoticeDto.Status;
    acknowledgementList: Array<MissionNoticeAcknowledgementDto>;
}
export namespace MissionNoticeDto {
    export type Status =
        | 'NOT_RELEVANT'
        | 'INFORMATIONAL'
        | 'APPLICABLE'
        | 'BLOCK';
    export const Status = {
        NOT_RELEVANT: 'NOT_RELEVANT' as Status,
        INFORMATIONAL: 'INFORMATIONAL' as Status,
        APPLICABLE: 'APPLICABLE' as Status,
        BLOCK: 'BLOCK' as Status
    };
}
